import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[NoSlash]'
})
export class NoSlash {

  constructor(private el: ElementRef) { }

  @Input() NoSlash: boolean;

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    let e = <KeyboardEvent> event;
    if (this.NoSlash) {
      if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) ||
        // Allow: Ctrl+C
        (e.keyCode == 67 && e.ctrlKey === true) ||
        // Allow: Ctrl+X
        (e.keyCode == 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
          // let it happen, don't do anything
          return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.keyCode === 191 || e.keyCode === 219 || e.keyCode === 221 || e.keyCode === 50 || e.keyCode ===51 || e.keyCode === 52 || e.keyCode === 190) ) {
            e.preventDefault();
        }

      }
  }
}


